import React, { useEffect, useState } from 'react';
import api from '../../lib/api';
import { responsiveImg } from '../../lib/imageUrl';
import { useText } from '../../lib/siteContent';

const Partners = () => {
  const [partners, setPartners] = useState([]);
  const t = useText();

  useEffect(() => {
    api.get('/partners')
      .then(({ data }) => setPartners(data))
      .catch(() => setPartners([]));
  }, []);

  if (partners.length === 0) return null;

  return (
    <section className="py-24 md:py-32 bg-[#FFFFFF] border-t border-[#111111]/10">
      <div className="container-custom">
        <div className="text-center mb-16">
          <span className="text-xs uppercase tracking-[0.4em] text-[#111111] mb-4 block">{t('partners.label')}</span>
          <h2 className="text-3xl md:text-5xl font-serif text-[#111111]">{t('partners.title')}</h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-px bg-[#111111]/10 border border-[#111111]/10">
          {partners.map((p) => {
            const inner = p.logoUrl ? (
              <img
                {...responsiveImg(p.logoUrl, '240px')}
                alt={p.name}
                className="max-h-12 md:max-h-14 max-w-[80%] object-contain transition-all duration-500 grayscale opacity-70 group-hover:grayscale-0 group-hover:opacity-100"
              />
            ) : (
              <span className="font-serif text-base md:text-lg text-[#6B6B6B] group-hover:text-[#111111] transition-colors text-center tracking-wide px-4">
                {p.name}
              </span>
            );
            const className = "bg-[#FFFFFF] aspect-[3/2] flex items-center justify-center group hover:bg-[#F5F5F5] transition-colors";
            return p.websiteUrl ? (
              <a
                key={p.id}
                href={p.websiteUrl}
                target="_blank"
                rel="noopener noreferrer"
                className={className}
                aria-label={p.name}
              >
                {inner}
              </a>
            ) : (
              <div key={p.id} className={className} title={p.name}>
                {inner}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Partners;
